module.exports = __webpack_public_path__ + "media/src/images/partners/wwf-46c168e4c7533c4f999478ce9aba4275.jpg";